const siteHeader = {
  siteNavigation() {
    let hamburgurMenu = document.getElementById("hamburgurMenu");
    let closeBtn = document.getElementById("closeBtn");
    let globalHeader = document.getElementById("globalHeader");
    let menuOverlay = document.getElementById("menuOverlay");

    function menuBehavior() {
      hamburgurMenu.classList.toggle("active");
      globalHeader.classList.toggle("floating_menu_open");
      document.body.classList.toggle("menu--active");
    }

    hamburgurMenu.addEventListener("click", function () {
      dataLayersWP.hamburgerMenu();
      menuBehavior();
    });

    closeBtn.addEventListener("click", function () {
      dataLayersWP.hamburgerMenuClose();
      menuBehavior();
    });

    menuOverlay.addEventListener("click", function () {
      dataLayersWP.hamburgerMenu();
      menuBehavior();
    });
  },
  notificationSlide() {
    if (jQuery('[data-element="notification"]').length > 0) {
      jQuery(window).on("load", function () {
        setTimeout(() => {
          jQuery('[data-element="notification"]').addClass("vspl__notification");
          jQuery('[data-notification="overlay"]').addClass("active");
          var notification = document.querySelector('[data-element="notification"]');
          if (dataLayersWP.isOnScreen(notification) == true) {
            dataLayersWP.notificationImpression();
          }
        }, 10000);
      });
    }
    jQuery(document).on("click", '[data-element="closenotification"]', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      jQuery('[data-element="notification"]').removeClass("vspl__notification");
      jQuery('[data-notification="overlay"]').removeClass("active");
      document.cookie = "notification=slide; path=/";
    }
    );
  },
  subMenu() {
    jQuery(document).on("click", "li.menu-item-has-children > a", function (e) {
      e.preventDefault();
      jQuery(this).parent(".menu-item-has-children").toggleClass("active");
      jQuery(this).next(".sub-menu").slideToggle();
    });
  },
  init() {
    if (jQuery('[data-element="edition"]').length == 0) {
      this.siteNavigation();
    }
    //this.notificationSlide();
    this.subMenu();
  },
};


/*$(window).on('scroll', function () {
  if ($(window).scrollTop() >= 330) {
    //$('.vspl__site--header--panel').addClass('fixed-panel').addClass('to-bottom');
    $('.vspl__site--footer--path').addClass('fixed-panel').addClass('to-top');
    $('.panel-menu').addClass('panel-layering');
  }

  else {
    //$('.vspl__site--header--panel').removeClass('fixed-panel').removeClass('to-bottom');
    $('.vspl__site--footer--path').removeClass('fixed-panel').removeClass('to-top');
    $('.panel-menu').removeClass('panel-layering');
  }
});*/

window.addEventListener("scroll", () => {
  document.querySelector(".vspl__site--header").classList.toggle("scrolled", window.scrollY > 50);
});





